import { watch, computed, ref, type Ref, type WritableComputedRef } from 'vue'
import { cloneDeep } from '@/helpers/clone-deep'

export function useInputRangeLazy<T>(
    value: WritableComputedRef<T> | Ref<T>,
    lazy: boolean
) {
    const valueImmediate = ref(cloneDeep(value.value)) as Ref<T>

    const onChange = () => {
        if (!lazy) {
            return
        }

        value.value = cloneDeep(valueImmediate.value)
    }

    watch(
        value,
        (val) => {
            valueImmediate.value = cloneDeep(val)
        },
        { immediate: true }
    )

    const valueUi = computed({
        get: () => (lazy ? valueImmediate.value : value.value),
        set: (val: T) => {
            if (lazy) {
                valueImmediate.value = val
            } else {
                value.value = val
            }
        },
    })

    return {
        valueUi,
        onChange,
    }
}
